module.exports = __webpack_public_path__ + "img/AC_S4_Header.6d6b5a5e.jpg";